module.exports = __webpack_public_path__ + "img/Karate.aa4305f0.png";